<template>
  <div :style="{
      backgroundImage:
        $store.state.user.level == 'İlkokul'
          ? 'url(/static/images/5183000.jpg) !important'
          : '',
      height: 'calc(100vh - 53px)',
      paddingTop: '50px',
      backgroundSize: 'cover',
    }">
    <el-drawer :destroy-on-close="true" class="aaaa" :append-to-body="true" title="Ayarlar" :visible.sync="settings"
      :with-header="false">
      <div class="row" style="padding: 50px">
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">Kelimeyi Otomatik Olarak Gizle</label>
          <el-switch style="margin-top: 8px" v-model="autoHide" :active-text="'Evet'" :active-value="1"
            :inactive-value="0" :inactive-text="'Hayır'">
          </el-switch>
        </div>
        <div class="col-md-12" v-if="autoHide == true">
          <label for="">Kelimeyi Otomatik Gizleme Süresi
            <span>{{ hideSpeed * 1000 }}ms.</span></label>
          <el-slider v-model="hideSpeed" :step="0.1" :min="0.1" :max="3" show-stops></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">Her Yeni Kelimede Yazı Boyutunu Düşürerek Git</label>
          <el-switch style="margin-top: 8px" v-model="autoDown" :active-text="'Evet'" :active-value="1"
            :inactive-value="0" :inactive-text="'Hayır'">
          </el-switch>
        </div>
        <div class="col-md-12">
          <label for="">Yazı Boyutu <span>{{ fontSize }}</span></label>
          <el-slider :disabled="autoDown === 1" v-model="fontSize" :step="1" :min="15" :max="100" show-stops></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">Gösterilecek Kelime Sayısı <span>{{ pickCount }}</span></label>
          <el-slider v-model="pickCount" :step="1" :min="1" :max="3" show-stops></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">Sonraki Kelimeye Geçme Yöntemi</label>
          <el-switch style="margin-top: 8px" v-model="nextMode" :active-text="'Kelime Doğru Bilindiğinde'"
            :active-value="1" :inactive-value="0" :inactive-text="'Boşluk Tuşuna Basıldığında'">
          </el-switch>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">Ekranın Faklı Yerlerinde Göster</label>
          <el-switch style="margin-top: 8px" v-model="randomPos" :active-text="'Evet'" :active-value="1"
            :inactive-value="0" :inactive-text="'Hayır'">
          </el-switch>
        </div>
        <div class="col-md-12 mb-3">
          <label for="">Kelime Seti (Her satıra bir adet)</label>
          <el-input :autosize="{ minRows: 2, maxRows: 8 }" type="textarea" v-model="text"></el-input>
          <el-button class="mt-2" size="mini" type="primary" round @click="initCustom">Kelime Setini İçe Aktar</el-button>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Renklendirme</label>
          <el-radio-group v-model="colorMode">
            <el-radio v-for="item in [
                'Yok',
                'İlk Hece Renkli',
                'Son Hece Renkli',
                'İlk ve Son Hece Renkli',
              ]" :label="item" :key="item" :value="item"></el-radio>
          </el-radio-group>
        </div>

        <div class="col-md-12 mt-4">
          <label for="">Hece Modu</label>
          <el-radio-group v-model="heceModu">
            <el-radio v-for="item in [
                'Yok',
                'İlk Hece Noktalı',
                'İlk Hece Altı Çizili',
                'Son Hece Noktalı',
                'Son Hece Altı Çizili',
              ]" :label="item" :key="item" :value="item"></el-radio>
          </el-radio-group>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Hece Vurgu Rengi</label>
          <el-color-picker color-format="rgb" show-alpha v-model="heceRengi"></el-color-picker>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme" @click="
        pause = true;
        $root.$emit('pause', true);
      ">
      <paused v-if="pause" @click="
          $root.$emit('pause', !pause);
          pause = false;
        "></paused>
      <a href="javascript:;" @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        " class="pause">
        <i :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
      </a>
      <a href="javascript:;" v-if="config == null || config == undefined" @click.stop="settings = true" class="settings">
        <i class="el-icon-setting"></i>
      </a>
      <div v-if="currentCounter != 0" class="dark-inverted" style="
          font-size: 20px;
          border-radius: 5px;
          cursor: pointer;
          display: inline-block;
          text-align: center;
          margin: 3px;
          display: flex;
          flex-direction: row;
        " :style="{
          marginRight: 5 + 'px',
          top: top + 'px',
          left: left + 'px',
          position: randomPos == 1 ? 'absolute' : '',
        }">
        <div v-for="item in options" :style="{ fontSize: fontSize + 'px' }"
          style="position: relative; line-height: 1em; margin-right: 0.2em">
          <span style="position: relative; z-index: 5">{{ item.text }}</span>
          <span v-if="colorMode.indexOf('İlk') != -1" style="position: absolute; left: 0; top: 0; z-index: 9"
            :style="{ color: heceRengi }">{{ item.heceler[0] }}</span>
          <span v-if="colorMode.indexOf('Son') != -1" style="position: absolute; right: 0; top: 0; z-index: 9"
            :style="{ color: heceRengi }">{{ item.heceler[item.heceler.length - 1] }}</span>

          <span v-if="heceModu.indexOf('İlk Hece Altı Çizili') != -1"
            style="position: absolute; left: 0; top: 0; z-index: 1" :style="{
              color: 'transparent',
              borderBottom: '.04em solid ' + heceRengi,
            }">{{ item.heceler[0] }}</span>
          <span v-if="heceModu.indexOf('Son Hece Altı Çizili') != -1"
            style="position: absolute; right: 0; top: 0; z-index: 1" :style="{
              color: 'transparent',
              borderBottom: '.04em solid ' + heceRengi,
            }">{{ item.heceler[item.heceler.length - 1] }}</span>

          <span v-if="heceModu.indexOf('İlk Hece Noktalı') != -1" style="
              position: absolute;
              left: 0;
              top: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1;
            " :style="{
              color: 'transparent',
            }">
            <span style="
                border-radius: 50%;
                position: absolute;
                bottom: -0.1em;
                width: 0.15em;
                height: 0.15em;
              " :style="{ backgroundColor: heceRengi }"></span>
            {{ item.heceler[0] }}
          </span>

          <span v-if="heceModu.indexOf('Son Hece Noktalı') != -1" style="
              position: absolute;
              right: 0;
              top: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1;
            " :style="{
              color: 'transparent',
            }">
            <span style="
                border-radius: 50%;
                position: absolute;
                bottom: -0.1em;
                width: 0.15em;
                height: 0.15em;
              " :style="{ backgroundColor: heceRengi }"></span>
            {{ item.heceler[item.heceler.length - 1] }}
          </span>
        </div>
      </div>
    </div>
    <div :style="{ width: wrapper.width + 'px' }" style="margin: 0 auto; border-radius: 0px; margin-top: 15px"
      v-if="nextMode === 1">
      <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
        " v-if="pause == false">
        <div style="
            display: flex;
            flex-direction: row;
            flex: 1;
            margin-right: 20px;
          ">
          <el-input :class="
              currentStatus == true
                ? 'status-true'
                : currentStatus == false
                ? 'status-false'
                : ''
            " @keyup.enter.native="check" style="font-size: 22px" v-model="answer"
            :placeholder="$t('module.tak.placeholder')"></el-input>
          <el-button style="margin-left: 10px" @click="check">></el-button>
        </div>
        <div style="display: flex; flex-direction: row">
          <span class="num" style="display: flex; align-items: center; justify-content: center">
            <div style="
                position: relative;
                z-index: 9999;
                background-color: red;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                color: white;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 22px;
              ">
              <i class="fas fa-times"></i>
            </div>
            <span style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: red;
                height: 40px;
                padding-left: 20px;
                margin-left: -20px;
                z-index: 1;
                position: relative;
                line-height: 45px;
                padding-right: 10px;
              ">{{ totalFalse }}</span>
          </span>
          <span class="num" style="display: flex; align-items: center; justify-content: center">
            <span style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: rgb(28, 68, 156);
                height: 40px;
                padding-right: 20px;
                margin-right: -20px;
                z-index: 0;
                position: relative;
                line-height: 45px;
                padding-left: 10px;
              ">{{ totalTrue }}</span>
          </span>
          <svg height="40px" viewBox="0 0 512 512" width="40px" xmlns="http://www.w3.org/2000/svg"
            style="position: relative; z-index: 2">
            <path
              d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
              fill="rgb(28, 68, 156)" />
            <path
              d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"
              fill="#fafafa" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import level1 from "./level1";
import level2 from "./level2";
import level3 from "./level3";
import level4 from "./level4";
import level5 from "./level5";
import level6 from "./level6";
import level7 from "./level7";
export default {
  props: ["config"],
  name: "GozEsnekligi",
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [
        2000, 1900, 1800, 1700, 1600, 1500, 1400, 1300, 1200, 1100, 1000, 800,
        600, 500, 400, 300,
      ],
      words: [
        level1
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k != ""),
        level2
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k != ""),
        level3
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k != ""),
        level4
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k != ""),
        level5
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k != ""),
        level6
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k != ""),
        level7
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k != ""),
      ],
      top: 0,
      left: 0,
      word: null,
      rotate: 0,
      currentCounter: 5,
      startCounter: 5,
      level: 1,
      options: [],
      currentLetter: null,
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      positions: [],
      totalTrue: 0,
      totalFalse: 0,
      counts: [],
      flash: false,
      answer: null,
      settings: false,
      autoLevel: false,
      levelLock: false,
      currentStatus: null,
      reactions: [],
      lastPickTime: new Date().getTime(),
      text: null,
      currentWords: [],
      autoHide: 0,
      hideSpeed: 1,
      nextMode: 0,
      fontSize: 17,
      autoDown: 0,
      randomPos: 0,
      top: 0,
      left: 0,
      heceModu: "",
      colorMode: "",
      heceRengi: "red",
      pickCount: 1,
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    window.removeEventListener("keyup", this.enterPress);
  },
  methods: {
    enterPress(event) {
      if (event.code === "Space") {
        if (this.nextMode == 0) {
          if (this.autoDown == 1) {
            if (this.fontSize == 15) {
              this.fontSize = 100;
            } else {
              this.fontSize -= 5;
            }
          }
          this.start();
        }
      }
    },
    initCustom() {
      this.currentWords = this.text.split(/\r?\n/).filter((k) => k != "");
      this.start();
    },
    pick(index) {
      this.options[index].picked = true;
    },
    getColor(letter) {
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == false
      ) {
        return "#ddd";
      }
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "green";
      }
      if (
        this.flash == false &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "green";
      }
      if (
        this.flash == false &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red";
      }
      if (
        this.flash == true &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red";
      }
    },
    check() {
      if (this.flash) return;
      this.flash = true;
      if (
        this.answer.trim().toLocaleLowerCase() ==
        this.options
          .map((k) => k.text)
          .join(" ")
          .trim()
          .toLocaleLowerCase()
      ) {
        this.totalTrue += 1;
        this.currentStatus = true;
        this.reactions.push(new Date().getTime() - this.lastPickTime);
      } else {
        this.totalFalse += 1;
        this.answer = this.currentLetter;
        this.currentStatus = false;
      }

      if (this.autoDown == 1) {
        if (this.fontSize == 15) {
          this.fontSize = 100;
        } else {
          this.fontSize -= 5;
        }
      }

      clearInterval(this.interval);
      setTimeout(() => {
        this.currentStatus = null;
        this.answer = "";
        this.start();
        this.flash = false;
      }, 2000);
    },
    start() {
      this.flash = false;
      this.positions = [];
      this.options = [];
      this.currentCounter = 1;

      for (let index = 0; index < this.pickCount; index++) {
        var text = _.shuffle(this.currentWords)[0];
        this.options.push({
          text: text,
          heceler: this.$hecele(text),
        });
      }

      var pos = this.getTextSize(
        this.options.map((k) => k.text).join(" "),
        "normal " + this.fontSize + "px" + " Arial"
      );

      if (pos.width > 700) {
        while (true) {
          this.fontSize -= 5;
          pos = this.getTextSize(
            this.options.map((k) => k.text).join(" "),
            "normal " + this.fontSize + "px" + " Arial"
          );
          if (pos.width < 700) {
            break;
          }
        }
      }

      this.left = _.random(10, 750 - pos.width);
      this.top = _.random(10, 550 - this.fontSize) - 20;

      console.log(pos.width, this.left);

      if (this.autoHide == 1) {
        this.interval = setTimeout(() => {
          this.currentCounter = 0;
          this.lastPickTime = new Date().getTime();
        }, this.hideSpeed * 1000);
      }
    },
    getTextSize(text, font) {
      const canvas =
        this.getTextSize.canvas ||
        (this.getTextSize.canvas = document.createElement("canvas"));
      const context = canvas.getContext("2d");
      context.font = font;
      const metrics = context.measureText(text);
      return {
        width: metrics.width,
        height:
          metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent,
      };
    },

    getCssStyle(element, prop) {
      return window.getComputedStyle(element, null).getPropertyValue(prop);
    },

    getCanvasFontSize(el = document.body) {
      const fontWeight = getCssStyle(el, "font-weight") || "normal";
      const fontSize = getCssStyle(el, "font-size") || "16px";
      const fontFamily = getCssStyle(el, "font-family") || "Times New Roman";

      return `${fontWeight} ${fontSize} ${fontFamily}`;
    },
    sesli(harf) {
      var sesliharfler = "aîûaeıioöuüAÎÛAEIİOÖUÜ";

      if (sesliharfler.indexOf(harf) > -1) {
        return true;
      } else {
        return false;
      }
    },
    hecele(s) {
      var ss = "";
      var hece = "";
      var boşluk = " ";
      var renkler = ["red", "blue"];
      var x = renkler.length;
      var sayaç = 0;

      var heceler = [];

      for (var i = s.length - 1; i >= 0; i--) {
        hece = s[i] + hece;
        if (
          s[i] == "'" &&
          i > 0 &&
          this.sesli(s[i - 1]) == true &&
          hece.length > 2
        ) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
        } else if (
          s[i] == "'" &&
          i > 1 &&
          this.sesli(s[i - 1]) == false &&
          this.sesli(s[i + 1]) == true
        ) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            s[i - 1] +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
          i--;
        } else {
          if (i == 0) {
            ss =
              "<span style='color:" +
              renkler[sayaç % x] +
              "'>" +
              hece +
              "</span>" +
              ss;
            heceler.push(hece);
            hece = "";
            sayaç++;
          } else {
            if (hece.length == 1) {
              if (
                i > 0 &&
                this.sesli(s[i]) == true &&
                this.sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }

            if (hece.length == 2) {
              if (
                hece[0] == "r" &&
                s[i - 1] == "t" &&
                this.sesli(s[i - 2]) == false
              ) {
              } else {
                if (i > 1 && s[i - 1] != "'") {
                  if (
                    this.sesli(s[i]) == false &&
                    this.sesli(s[i + 1]) == true
                  ) {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                  if (
                    this.sesli(s[i]) == true &&
                    this.sesli(s[i - 1]) == true
                  ) {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                } else if (
                  this.sesli(s[i]) == false &&
                  this.sesli(s[i - 1]) == true &&
                  this.sesli(s[i + 1]) == true
                ) {
                  ss =
                    "<span style='color:" +
                    renkler[sayaç % x] +
                    "'>" +
                    hece +
                    "</span>" +
                    ss;
                  heceler.push(hece);
                  hece = "";
                  sayaç++;
                }
              }
            }

            if (hece.length == 3) {
              if (i > 1) {
                if (
                  hece[0] == "r" &&
                  s[i - 1] == "t" &&
                  this.sesli(s[i - 2]) == false
                ) {
                } else {
                  if (this.sesli(s[i]) == false && s[i - 1] != "'") {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                }
              } else if (
                this.sesli(s[i]) == false &&
                this.sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }

            if (hece.length == 4) {
              ss =
                "<span style='color:" +
                renkler[sayaç % x] +
                "'>" +
                hece +
                "</span>" +
                ss;
              heceler.push(hece);
              hece = "";
              sayaç++;
            }
          }
        }
      }

      return heceler.reverse();
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    autoDown: function () {
      if (this.autoDown == 1) {
        this.fontSize = 100;
      }
    },
    currentSpeed: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    level: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    totalTrue: function () {
      if (this.autoLevel == 0) return;
      this.levelLock = true;

      if (this.totalTrue % 2 == 0) {
        this.speed += 1;
      }
      if (this.totalTrue % 6 == 0) {
        this.level = Math.min(this.level + 1, 7);
      }

      setTimeout(() => {
        this.levelLock = false;
      }, 500);
    },
    totalFalse: function () {
      if (this.autoLevel == 0) return;
      this.levelLock = true;
      if (this.speed == 1) {
        this.speed = this.level == 1 ? 1 : this.speeds.length - 1;
        this.level = Math.max(this.level - 1, 1);
      } else {
        this.speed -= 1;
      }

      setTimeout(() => {
        this.levelLock = false;
      }, 500);
    },
  },
  created() {
    if (this.config != null && this.config != undefined) {
      if (this.config.level != null && this.config.level != "")
        this.level = this.config.level;
      if (this.config.speed != null && this.config.speed != "")
        this.speed = this.config.speed;
      this.autoLevel = this.config.auto_level;
    }

    this.currentWords = this.words[this.level - 1];

    document.addEventListener("keyup", this.enterPress);
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 800px;
  height: 600px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-color: white !important;

  .el-input__inner {
    transition: 0.5s;
  }
}
</style>

<style lang="less">
.status-true .el-input__inner {
  background-color: #1c449c !important;
  transition: 0.5s;
  color: white !important;
}

.status-false .el-input__inner {
  background-color: red !important;
  transition: 0.5s;
  color: white !important;
}
</style>
<style lang="less">
.aaaa {
  label {
    display: block;
  }

  .el-select {
    width: 100%;
  }

  .el-radio-group {
    font-size: 0;
    width: 100%;
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-direction: column;
  }
}
</style>

<style>
.el-color-picker__panel {
  z-index: 999999999999 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/KelimeEgzersizi.vue